import React from 'react';
import './game-settings-modal.css';
import { Paragraph } from '../../paragraph';
import { RadioButtonGroup } from '../../radio-button-group';
import { Icon } from '../../icon';
import { Heading } from '../../heading';
import Copy from '../../../copy/game-settings';

const GameSettingsModal = props => {
    const { screen, checked, onRadioSelect } = props;

    return (
        <>
            <header className="game-settings-modal__header">
                <Icon iconName={screen} colorScheme="dark" withSpacing={true} />
                <Heading
                    headingType="h3"
                    colorScheme="dark"
                    align="center"
                    withSpacing={false}
                >
                    {Copy[screen].heading}
                </Heading>
            </header>
            <div className="game-settings-modal__content">
                <>
                    <Paragraph
                        colorScheme="dark"
                        textAlign="center"
                        withSpacing={false}
                    >
                        {Copy[screen].settings}
                    </Paragraph>
                    <RadioButtonGroup
                        options={Copy[screen].options}
                        group={Copy[screen].settings}
                        onChange={onRadioSelect}
                        checked={checked}
                        size="small"
                    />
                </>
            </div>
        </>
    );
};

export { GameSettingsModal };
